import axios from 'axios'
import { initShopeepayReporter, instrumentAxios } from '@shopeepay/reporter'

// MY uses a /:language prefix scheme (en/zh/ms). Declare both bare and
// language-prefixed templates so /en/about-us → /:language/about-us etc.
const KNOWN_ROUTES = [
  '/',
  '/#about',
  '/#aboutUs',
  '/merchant#merchantApp',
  '/:language',
  '/about-us',                       '/:language/about-us',
  '/insurance',                      '/:language/insurance',
  '/insurance/car',                  '/:language/insurance/car',
  '/insurance/motorcycle',           '/:language/insurance/motorcycle',
  '/merchant',                       '/:language/merchant',
  '/merchant/be-a-partner',          '/:language/merchant/be-a-partner',
  '/merchant/quick-funds',           '/:language/merchant/quick-funds',
  '/merchant/sloan-for-sellers',     '/:language/merchant/sloan-for-sellers',
  '/privacy',                        '/:language/privacy',
  '/shopeepay',                      '/:language/shopeepay',
  '/sloan',                          '/:language/sloan',
  '/spaylater',                      '/:language/spaylater',
  '/terms',                          '/:language/terms',
]

initShopeepayReporter({
  region: 'my',
  project: 'shopeepay-my',
  knownRoutes: KNOWN_ROUTES,
})
instrumentAxios(axios, 'shopeepay-my')
